import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withKeys as _withKeys, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-14b15fa8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-wrapper" }
const _hoisted_2 = { class: "right-wrapper el-card" }
const _hoisted_3 = { class: "header-wrapper" }
const _hoisted_4 = { class: "action-row cm-ui-mb15" }
const _hoisted_5 = { class: "port-list-tip-count" }

import { computed, reactive, ref } from 'vue'
import { ElMessage } from 'element-plus'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import ContentAdaptLayout from '@/views/dashboard/_components/content-adapt-layout/content-adapt-layout.vue'
import CmTable from '@/components/cmTable/index.vue'
import type { TableOpt } from '@/components/cmTable/types'
import { useCmTableListRefresh } from '@/hooks/use-cm-table-list-refresh'
import BaseTree from '@/views/dashboard/_components/group-tree/base-tree.vue'
import CmTableSelectionTipBar from '@/views/dashboard/_components/cmtable-selection-tip-bar/cmtable-selection-tip-bar.vue'
import type { Group } from '@/views/dashboard/_type/group'
import UnauthorizedTooltip from '@/views/dashboard/_components/unauthorized-tooltip/unauthorized-tooltip.vue'
import { TableDataRowState, TableState } from '@/services/table-memory-pagination'
import {
  BaseLineScanTerminalDrawerService,
  CheckResult,
  QueryParams,
  ScanParams,
  TerminalItem
} from '@/views/dashboard/safe-status/base-line/_components/baseLine-scan-terminal-drawer/baseLine-scan-terminal-drawer.service'
import { getAuthByList, PermissionFe } from '@/services/service-permission.service'
import { AreaType } from '@/views/dashboard/service/_enum/area-type'
import { TerminalAuthStatus } from '@/views/dashboard/_enum/terminal-auth-status'
import { formatTimeStamp } from '@/utils/time'


export default /*#__PURE__*/_defineComponent({
  __name: 'baseLine-scan-terminal-drawer',
  emits: ["syncScanTaskId", "syncScanDeviceCount", "closeTerminalDrawer", "authSuccess"],
  setup(__props, { emit: __emit }) {

const emit = __emit

const { t, locale } = useI18n()
const injector = useReflectiveInjector([BaseLineScanTerminalDrawerService])
const service = injector.get(BaseLineScanTerminalDrawerService)

const ModulePermissionKey = {
  [AreaType.linux]: PermissionFe.linux_base_auth,
}

function isDisabled(row: TerminalItem) {
  return getAuthByList(row.auth_status, ModulePermissionKey[row.area_type]) !== TerminalAuthStatus.normal
}

service.isDisabled = isDisabled

const tableRef = ref<{ getList: () => Promise<unknown> } | null>(null)
const { refreshList } = useCmTableListRefresh(tableRef)

const listForm = reactive<QueryParams>({
  group_id: -1,
  key_word: '',
  page: 1,
  limit: 20,
  asc: false,
  sort: '',
  useMemory: false,
  check_result: CheckResult.all,
  permission_names: [ModulePermissionKey[AreaType.linux]],
})

const viewData = ref({
  tableData: [] as TableDataRowState<TerminalItem>[],
  state: {} as TableState<TableDataRowState<TerminalItem>>,
  total: 0,
})

/** CmTable dataFormate 产出的渲染数据引用，直接修改其元素 $selected 可触发 Vue 响应式更新 */
const renderedData = ref<TableDataRowState<TerminalItem>[]>([])

/** 本次 listApi 是否为滚动加载追加（listApi 先于 dataFormate 执行，这里传递模式） */
let isAppendMode = false

function pullServiceState() {
  const state = service.getViewState()
  viewData.value.state = state
  viewData.value.tableData = state.data.list
  viewData.value.total = state.data.total
}

function listDataFormate(rows: TableDataRowState<TerminalItem>[] = []) {
  const { selectAll } = service.getViewState()
  const selectedData = service.getSelectedData()
  // 参照 BaseLineRepairDrawer：返回新对象 + 新数组，让 Vue 能检测到引用变化触发重渲染
  const formatted = rows.map(row => ({
    ...row,
    $selected: selectAll ? !isDisabled(row) : !!selectedData.find(r => service.isEqual(r, row))
  }))
  // 滚动加载时 listApi 只返回新增 chunk，渲染数据需拼接而不是替换（与 CmTable 内部 concat 一致）
  renderedData.value = isAppendMode ? [...renderedData.value, ...formatted] : formatted
  return formatted
}

const tableOpt = computed<TableOpt>(() => {
  void locale.value
  return {
    showTip: false,
    selection: false,
    rowKey: 'device_id',
    path: 'list',
    totalPath: 'total',
    height: '100%',
    showActionBar: false,
    showSearch: false,
    showRightToolbar: false,
    containerOpt: { style: { flex: '1', minHeight: 0, overflow: 'hidden' } },
    columns: [
      {
        prop: '__sel',
        label: '',
        width: 52,
        columnOpt: { fixed: 'left', align: 'center' }
      },
      {
        prop: 'computer_name',
        label: t('listColumns.computerName'),
        type: 'COMPUTER',
        columnOpt: { minWidth: 180 }
      },
      {
        prop: 'user_mark',
        label: t('listColumns.userMark'),
        columnOpt: { minWidth: 130 },
        formatter: (_row: TerminalItem, value: string) => value || '--'
      },
      {
        prop: 'system_ip',
        label: t('listColumns.ipAddress'),
        type: 'IP',
        columnOpt: { minWidth: 140 }
      },
      {
        prop: 'system_name',
        label: t('safeProtectionModule.os'),
        columnOpt: { minWidth: 140 }
      },
      {
        prop: 'last_check_time',
        label: t('safeProtectionModule.lastScanCol'),
        columnOpt: { minWidth: 150 },
        formatter: (_row: TerminalItem, value: number) => {
          return value ? formatTimeStamp(value, 'YYYY-MM-DD HH:mm') : t('safeProtectionModule.notScanned')
        }
      }
    ],
  }
})

async function listApi(params: Record<string, unknown>) {
  listForm.page = Number(params.page) || 1
  listForm.limit = Number(params.limit) || 20
  if (params.sort !== undefined) {
    listForm.sort = params.sort as string
  }
  if (params.asc !== undefined) {
    listForm.asc = params.asc as boolean
  }
  // 滚动加载：page > 1 视为追加，服务状态累积全部已加载页（参照 file-dispatch dispatch-terminal）
  isAppendMode = listForm.page > 1
  const prevLen = isAppendMode ? service.getViewState().data.list.length : 0
  await service.refresh(listForm, isAppendMode)
  pullServiceState()
  const listChunk = isAppendMode ? viewData.value.tableData.slice(prevLen) : viewData.value.tableData
  return {
    list: listChunk,
    total: viewData.value.total
  }
}

function rowSelectable(row: TableDataRowState<TerminalItem>) {
  return !isDisabled(row)
}

const hasSelectableRows = computed(() => renderedData.value.some(rowSelectable))

function tipBarSelectedCount() {
  if (viewData.value.state.selectAll) return viewData.value.state.selectCount
  return renderedData.value.filter((r) => r.$selected).length
}

function pageSelectAllChecked(rows: TableDataRowState<TerminalItem>[]) {
  const enabled = rows.filter((r) => rowSelectable(r))
  return enabled.length > 0 && enabled.every(r => r.$selected)
}

function pageSelectAllIndeterminate(rows: TableDataRowState<TerminalItem>[]) {
  const enabled = rows.filter((r) => rowSelectable(r))
  return enabled.some(r => r.$selected) && !enabled.every(r => r.$selected)
}

function pageHeaderAllDisabled(rows: TableDataRowState<TerminalItem>[]) {
  if (!rows.length) return true
  return !rows.some((r) => rowSelectable(r))
}

function handlePageSelectAllHeader(rows: TableDataRowState<TerminalItem>[], checked: boolean) {
  const enabled = rows.filter((r) => rowSelectable(r))
  if (checked) {
    // 直接修改渲染数据上的 $selected，走 Vue Proxy 触发响应式
    enabled.forEach(r => { r.$selected = true })
    service.mergeSelectedData(enabled)
  } else {
    rows.forEach(r => { r.$selected = false })
    service.mergeSelectedData([])
  }
  pullServiceState()
}

function handleCheckbox(row: TableDataRowState<TerminalItem>) {
  if (viewData.value.state.selectAll) return
  // 直接修改渲染数据上的 $selected，走 Vue Proxy 触发响应式
  row.$selected = !row.$selected
  service.mergeSelectedData(service.getSelectedData(), row)
  pullServiceState()
}

async function getData(isKeepPage = false) {
  if (!isKeepPage) {
    listForm.page = 1
  }
  await refreshList()
}

async function handleSearch() {
  listForm.page = 1
  await getData()
}

async function scanTer() {
  const params: ScanParams = {
    select_type: 1,
    device_list: [],
    group_id: listForm.group_id
  }
  if (viewData.value.state.selectAll) {
    params.select_type = 2
  } else {
    params.device_list = service.getSelectedData().map(item => item.device_id)
  }
  try {
    const res = await service.getRescan(params)
    localStorage.setItem('BASELINE_SCAN_TASK_ID', res.task_id)
    emit('syncScanTaskId', res.task_id)
    emit('syncScanDeviceCount', res.device_count)
    emit('closeTerminalDrawer')
  } catch {
    ElMessage.error(t('common.failed'))
  }
}

async function terminalGroupSelected(row: Group) {
  listForm.useMemory = false
  service.cancelSelectAll()
  listForm.group_id = row.group_id
  pullServiceState()
  await getData()
}

function handleTipSelect(type: 'all' | 'reverse') {
  const enabled = renderedData.value.filter((r) => rowSelectable(r))
  if (type === 'all') {
    // 直接修改渲染数据上的 $selected
    enabled.forEach(r => { r.$selected = true })
    service.mergeSelectedData(enabled)
    pullServiceState()
    return
  }
  // reverse: 逐个翻转
  for (const row of enabled) {
    row.$selected = !row.$selected
    service.mergeSelectedData(service.getSelectedData(), row)
  }
  pullServiceState()
}

async function selectAll() {
  listForm.page = 1
  listForm.useMemory = false
  service.selectAll()
  pullServiceState()
  // 先刷新列表数据，让 CmTable 内部 data.value 替换为新对象并触发重渲染，checkbox 才能同步勾选
  await getData()
}

async function selectCancel() {
  listForm.useMemory = false
  service.cancelSelectAll()
  pullServiceState()
  await getData()
}

function calcSelectAllScopeDisabled() {
  if (!viewData.value.total || viewData.value.state.selectAll) return true
  return !hasSelectableRows.value
}

async function handleAuthSuccess() {
  await getData()
  emit('authSuccess')
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!

  return (_openBlock(), _createBlock(ContentAdaptLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(BaseTree, {
          "terminal-type": [1, 2, 3],
          onTerminalGroupSelected: terminalGroupSelected
        }),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(CmTable, {
            ref_key: "tableRef",
            ref: tableRef,
            modelValue: listForm,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((listForm) = $event)),
            class: "scan-drawer-cmtable",
            "table-opt": tableOpt.value,
            api: listApi,
            "data-formate": listDataFormate,
            "page-option": { pageNumName: 'page', pageSizeName: 'limit' },
            "first-loading": true
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    disabled: !viewData.value.state.selectCount,
                    size: "mini",
                    onClick: scanTer
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('safeProtectionModule.baselineStartScan')), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_el_input, {
                    modelValue: listForm.key_word,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((listForm.key_word) = $event)),
                    modelModifiers: { trim: true },
                    size: "small",
                    class: "cm-ui-ml10 keyword-input",
                    clearable: "",
                    placeholder: _ctx.$t('common.phComputerUserIp'),
                    "suffix-icon": "el-icon-search",
                    onKeyup: _withKeys(handleSearch, ["enter"]),
                    onBlur: handleSearch,
                    onClear: handleSearch
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _createVNode(CmTableSelectionTipBar, { "bar-height": 34 }, {
                  summary: _withCtx(() => [
                    _createVNode(_component_i18n_t, {
                      keypath: "portManage.tipSelectedTerminalsTotal",
                      tag: "span",
                      class: "port-list-tip-bar__summary"
                    }, {
                      count: _withCtx(() => [
                        _createElementVNode("span", _hoisted_5, _toDisplayString(tipBarSelectedCount()), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  actions: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "text",
                      class: "cm-btn-text",
                      disabled: !viewData.value.tableData.length || viewData.value.state.selectAll,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (handleTipSelect('all')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('portManage.pageSelectAll')), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_el_button, {
                      type: "text",
                      class: "cm-btn-text",
                      disabled: !viewData.value.tableData.length || viewData.value.state.selectAll,
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (handleTipSelect('reverse')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('sensitiveFileScanning.reversePage')), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_el_button, {
                      type: "text",
                      class: "cm-btn-text",
                      disabled: calcSelectAllScopeDisabled(),
                      onClick: selectAll
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('portManage.selectAllTerminals')), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_el_button, {
                      type: "text",
                      class: "cm-btn-text",
                      disabled: !viewData.value.tableData.some((item) => item.$selected) && !viewData.value.state.selectAll,
                      onClick: selectCancel
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('sensitiveFileScanning.cancelSelect')), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                })
              ])
            ]),
            "__sel-header": _withCtx(({ data }) => [
              _createVNode(_component_el_checkbox, {
                "model-value": pageSelectAllChecked(data),
                disabled: !data.length || viewData.value.state.selectAll || pageHeaderAllDisabled(data),
                indeterminate: pageSelectAllIndeterminate(data),
                onChange: (v) => handlePageSelectAllHeader(data, !!v)
              }, null, 8, ["model-value", "disabled", "indeterminate", "onChange"])
            ]),
            __sel: _withCtx(({ row }) => [
              _createVNode(UnauthorizedTooltip, {
                "permission-key": ModulePermissionKey[row.area_type],
                "device-id": row.device_id,
                "auth-status": _unref(getAuthByList)(row.auth_status, ModulePermissionKey[row.area_type]),
                "area-type": row.area_type,
                onAuthSuccess: handleAuthSuccess
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_checkbox, {
                    "model-value": row.$selected,
                    disabled: viewData.value.state.selectAll || isDisabled(row),
                    onChange: () => handleCheckbox(row)
                  }, null, 8, ["model-value", "disabled", "onChange"])
                ]),
                _: 2
              }, 1032, ["permission-key", "device-id", "auth-status", "area-type"])
            ]),
            _: 1
          }, 8, ["modelValue", "table-opt"])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})